import { Box, Skeleton } from "@mui/material";

const loaderStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "543px",
    maxWidth: "100%",
  },
  header: {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    userInfo: {
      display: "flex",
      gap: "12px",
    },
    userDetails: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    rating: {
      display: "flex",
      gap: "4px",
    },
  },
  body: {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
    },
    titleRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    comment: {
      borderRadius: "8px",
    },
  },
};

const ServiceFeedbackCardLoader = () => {
  return (
    <Box sx={loaderStyles.container}>
      <Box sx={loaderStyles.header.container}>
        <Box sx={loaderStyles.header.userInfo}>
          <Skeleton variant="circular" width={48} height={48} />
          <Box sx={loaderStyles.header.userDetails}>
            <Skeleton variant="text" width={120} height={24} />
            <Skeleton variant="text" width={180} height={18} />
          </Box>
        </Box>
        <Box sx={loaderStyles.header.rating}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} variant="circular" width={20} height={20} />
          ))}
        </Box>
      </Box>

      <Box sx={loaderStyles.body.container}>
        <Box sx={loaderStyles.body.titleRow}>
          <Skeleton variant="text" width={200} height={28} />
          <Skeleton variant="text" width={80} height={18} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={192} sx={loaderStyles.body.comment} />
      </Box>
    </Box>
  );
};

export default ServiceFeedbackCardLoader;
